import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./../../e-commercepages/src/styles/select2.css";
import "./../../e-commercepages/src/styles/animate.css";
import "./../../e-commercepages/src/styles/font-awesome.css";
import "./../../e-commercepages/src/styles/jquery.fancybox.css";
import "./../../e-commercepages/src/styles/main.css";
import "./../../e-commercepages/src/styles/owl.carousel.css";
import "./../../e-commercepages/src/tuner/css/colorpicker.css";
import "./../../e-commercepages/src/tuner/css/styles.css";
import "./../../e-commercepages/src/rs-plugin/css/settings.css";
import "./../../e-commercepages/src/img/favicon.png";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
